import { IELTData } from 'legacy/lut/classes/models/partner360/ELT/IELTData'
import EltStoreService from 'legacy/lut/classes/services/EltStoreService'

interface IGetCompanyName {
  partnerId: string
  data: IELTData
  forceFetch?: boolean
}
export const getCompanyName = async ({ partnerId, forceFetch, data }: IGetCompanyName) => {
  if (data.PartnerName && !forceFetch) {
    return data.PartnerName
  }

  const companyData = await EltStoreService.getCompanyByPartnerId(partnerId)
  return companyData?.CommunicationName || ''
}
